<div class="entity">
	<router-outlet>
	</router-outlet>
</div>
